import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // deyisenleri global olanlari burada teyin edirik
    url: "/api",
    specialities: [],
    clinics: [],
  },
  mutations: {
    // mutationun isi state deyerini deyismekdi
    // ---------------------------
    // initState(state, items){
    //     state.items = items
    // }
    // ---------------------------

    initSpecialities(state, specialities) {
      state.specialities = specialities;
    },
    initClinics(state, clinics) {
      state.clinics = clinics;
    },
  },
  actions: {
    // asenkron olaraq alacaqimiz islerde database api falan bunu istifade edeceyik

    updateSpecialities(context, specialities) {
      context.commit("initSpecialities", specialities);
    },
    updateClinics(context, clinics) {
      context.commit("initClinics", clinics);
    },
  },
  getters: {
    // state icindeki datayi bize geri dondurur
    // ----------------------------
    // getState(state){
    //     return state.items
    // }
    // ----------------------------
    // istifade seklidi de buna benzerdir parametre olaraq state alir ve oda yuxarida gosterilen state gosterir
    getUrl(state) {
      return state.url;
    },
    getSpecialities(state) {
      return state.specialities;
    },
    getcClinics(state) {
      return state.clinics;
    },
  },
});
